import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
declare let gtag: Function;
@Component({
  selector: 'fa-non-collateral-loan-details',
  templateUrl: './non-collateral-loan-details.component.html',
  styleUrls: ['./non-collateral-loan-details.component.scss']
})
export class NonCollateralLoanDetailsComponent implements OnInit {

  model: any = {};
  dataModel: string = "loan-applications";
  isPartnerLink: boolean = false;
  partnerLogo: string;
  coapplicantNewRelationOptions = this.configService.getConfig1("foreignAssist", "coapplicantNewRelationOptions");
  coapplicantOccupationOptions = this.configService.getConfig1("foreignAssist", "coapplicantOccupationList");
  loanWidgetConfig: any = this.configService.getConfig1("loanWidgetConfig");
  steps = this.loanWidgetConfig.loanDetailsStepperConfig;
  layout: FormlyFieldConfig[];

  collateralTypeOptions: any[] = [
    { label: "Residential", value: "residential" },
    { label: "Commercial", value: "commercial" },
    { label: "Plot", value: "plot" },
    { label: "Fixed Deposit", value: "fixedDeposit" },
    { label: "Others", value: "others" }
  ]

  coapplicantAnnualIncomeOptions = this.configService.getConfig1("foreignAssist", "coApplicantIncomeOptions");

  orientation: String;
  defaultAddress: string;

  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }
  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }

  configNonCollateralDetailsHeader: HeaderInterface = {
    title: "Co-applicant Details",
    back: {
      link: '/loan-details',
      step: 'firstStep'
    }
  }


  userData: {};

  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private configService: ConfigService,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {

    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      localStorage.setItem('puid', puid);
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }

    }
    this.checkUserLoggedIn();
  }
  setMobileLayout() {
    this.layout = [
      {
        fieldGroupClassName: 'row mb-3 padding-custom custom-height-nonCollateral',
        fieldGroup: [

          {
            className: 'col-12',
            key: "coApplicantName",
            type: 'input-tooltip',
            templateOptions: {
              label: 'Co-applicant Name',
              placeholder: "Type the name of your co-applicant",
              required: true,
              tooltip: "Please apply with primary coapplicant. You can add more coapplicants later in the notes section post successful loan application"
            },
          },

          {
            className: 'col-12 mobile-number-length',
            key: "coApplicantPhoneNumber",
            type: 'mobile-number',
            templateOptions: {
              label: 'Co-applicant Mobile Number',
              required: true,
            },
            asyncValidators: {
              shouldNotSame: {
                expression: async (control, model) => {

                  let val = await this.checkMobileAvailable(control.value)
                  if (val) {
                    this.apiHelper.openSnackBar("This number already exists.")
                  }
                  return !val;

                },
                message: (error: any, field: FormlyFieldConfig) => `${field.formControl.value} number is already registered.`,
              }
            },
            validation: {
              messages: {
                shouldNotSame: 'Student mobile number cannot be same as co-applicant mobile number',
              },
            },
          },

          {
            className: 'col-12',
            key: "coApplicantRelation",
            type: 'select',
            templateOptions: {
              label: 'Your relationship with the co-applicant?',
              placeholder: "Select your relation with co-applicant",
              required: true,
              options: this.coapplicantNewRelationOptions,
            },
          },



          {
            className: 'col-12',
            key: "coApplicantOccupation",
            type: 'radio',
            templateOptions: {
              label: 'Coapplicant Occupation',
              placeholder: "Select co-applicant occupation",
              required: true,
              options: this.coapplicantOccupationOptions,
            },
          },

          {
            className: "col-12",
            key: "coApplicantProfession",
            type: "input",
            templateOptions: {
              label: "Co-applicant Profession",
              placeholder: "Type the Designation of your co-applicant",
              required: true
            },
            validation: {
              messages: {
                required: 'Please select co-applicant profession option',
              },
            },
          },

          {
            className: "col-12 mb-2",
            key: "coApplicantIncome",
            type: "currency",
            templateOptions: {
              label: "Co-applicant Monthly Income",
              placeholder: "Enter the monthly income",
              required: true,
              showCurrency: true
            },
            validation: {
              messages: {
                required: 'Please Enter the Monthly Income',
              },
            },
          },

          {
            className: 'col-12 mt-2',
            key: 'coApplicantPan',
            type: 'pan',
            templateOptions: {
              label: 'Co-applicant PAN Number',
              placeholder: 'eg. ABCD1234E'
            },
            asyncValidators: {
              shouldNotSame: {
                expression: async (control: any) => {
                  if (control?.value === undefined || control.value === '') {
                    return true
                  }
                  else if (control?.value !== undefined || control.value !== '') {
                    let val = await this.checkPanNumber(control.value)
                    if (val) {
                      this.apiHelper.openSnackBar("This pan is already registered")
                    }
                    return !val;
                  }


                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} is already registered.`,
              }
            },
            validation: {
              messages: {
                shouldNotSame: 'Student PAN number cannot be same as co-applicant PAN number',
              },
            },
          },

          {
            className: 'col-12',
            key: 'coApplicantPincode',
            type: 'autocomplete',
            templateOptions: {
              label: 'Enter your Co-applicant Pincode',
              required: true,
              placeholder: 'eg. 422010',
              autocompleteOptions: {
                name: 'pincode',
                value: 'pincode',
                fields: ['pincode', 'city', 'state'],
                dataModel: 'locations',
                isEditable: false,
                defaultValue: this.model?.coApplicantPincode,
                onSelect: (item: any) => {
                  this.model.coApplicantPincode = item.pincode
                },
                dataParams: {
                  aggregate: true
                },
              }
            },
          },
        ]
      },
      {
        fieldGroupClassName: "d-flex justify-content-center padding-custom",
        fieldGroup: [
          {
            className: "submit-button",
            type: "button",
            templateOptions: {
              btnType: "primary px-10 rounded-1 py-2",
              type: "submit",
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.coApplicantName === undefined || this.model?.coApplicantRelation === undefined || this.model?.coApplicantPhoneNumber === undefined || this.model?.coApplicantOccupation === undefined || this.model?.coApplicantProfession === undefined || this.model?.coApplicantIncome === undefined || this.model?.coApplicantPincode === undefined) {
                  this.model["error"] = "Hello world"
                }
                else {
                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                    }
                    if (this.loanService.partnerDetails) {
                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company.name;
                    }
                    this.trackEvent("Next Button of Collateral Loan on Loan Widget  Clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if (this.orientation === "vertical") {
                  if ([undefined, "", " "].includes(this.model?.coApplicantName) || [undefined, "", " "].includes(this.model?.coApplicantRelation) || [undefined, "", " "].includes(this.model?.coApplicantPhoneNumber) || [undefined, "", " "].includes(this.model?.coApplicantOccupation) || [undefined, "", " "].includes(this.model?.coApplicantProfession) || [undefined, "", " "].includes(this.model?.coApplicantIncome) || [undefined, "", " "].includes(this.model?.coApplicantPincode)) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom "
                  }
                }
              }
            },
          },
        ]
      }
    ];
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: 'row mb-6 padding-custom custom-height-nonCollateral-web',
        fieldGroup: [

          {
            className: 'col-12 mb-2',
            key: "coApplicantName",
            type: 'input-tooltip',
            templateOptions: {
              label: 'Co-applicant Name',
              placeholder: "Type the name of your co-applicant",
              required: true,
              tooltip: "Please apply with primary coapplicant. You can add more coapplicants later in the notes section post successful loan application"
            },
          },

          {
            className: 'col-12',
            key: "coApplicantPhoneNumber",
            type: 'mobile-number',
            templateOptions: {
              label: 'Co-applicant Mobile Number',
              required: true,
            },
            asyncValidators: {
              shouldNotSame: {
                expression: async (control, model) => {

                  let val = await this.checkMobileAvailable(control.value)
                  if (val) {
                    this.apiHelper.openSnackBar("This number already exists.")
                  }
                  return !val;

                },
                message: (error: any, field: FormlyFieldConfig) => `${field.formControl.value} number is already registered.`,
              }
            },
            validation: {
              messages: {
                shouldNotSame: 'Student mobile number cannot be same as co-applicant mobile number',
              },
            },
          },

          {
            className: 'col-12',
            key: "coApplicantRelation",
            type: 'select',
            templateOptions: {
              label: 'Your relationship with the co-applicant?',
              placeholder: "Select your relation with co-applicant",
              required: true,
              options: this.coapplicantNewRelationOptions,
            },
          },



          {
            className: 'col-12',
            key: "coApplicantOccupation",
            type: 'radio',
            templateOptions: {
              label: 'Coapplicant Occupation',
              placeholder: "Select co-applicant occupation",
              required: true,
              options: this.coapplicantOccupationOptions,
            },
          },

          {
            className: "col-12",
            key: "coApplicantProfession",
            type: "input",
            templateOptions: {
              label: "Co-applicant Profession",
              placeholder: "Type the Designation of your co-applicant",
              required: true
            },
            validation: {
              messages: {
                required: 'Please select co-applicant profession option',
              },
            },
          },

          {
            className: "col-12 mb-2",
            key: "coApplicantIncome",
            type: "currency",
            templateOptions: {
              label: "Co-applicant Monthly Income",
              placeholder: "Enter the monthly income",
              required: true,
              showCurrency: true
            },
            validation: {
              messages: {
                required: 'Please Enter the Monthly Income',
              },
            },
          },

          {
            className: 'col-12 mt-2',
            key: 'coApplicantPan',
            type: 'pan',
            templateOptions: {
              label: 'Co-applicant PAN Number',
              placeholder: 'eg. ABCD1234E'
            },
            asyncValidators: {
              shouldNotSame: {
                expression: async (control: any) => {
                  if (control?.value === undefined || control.value === '') {
                    return true
                  }
                  else if (control?.value !== undefined || control.value !== '') {
                    let val = await this.checkPanNumber(control.value)
                    if (val) {
                      this.apiHelper.openSnackBar("This pan is already registered")
                    }
                    return !val;
                  }


                },
                message: (error, field: FormlyFieldConfig) => `${field.formControl.value} is already registered.`,
              }
            },
            validation: {
              messages: {
                shouldNotSame: 'Student PAN number cannot be same as co-applicant PAN number',
              },
            },
          },

          {
            className: 'col-12',
            key: 'coApplicantPincode',
            type: 'autocomplete',
            templateOptions: {
              label: 'Enter your Co-applicant Pincode',
              required: true,
              placeholder: 'eg. 422010',
              autocompleteOptions: {
                name: 'pincode',
                value: 'pincode',
                fields: ['pincode', 'city', 'state'],
                dataModel: 'locations',
                isEditable: false,
                defaultValue: this.model?.coApplicantPincode,
                onSelect: (item: any) => {
                  this.model.coApplicantPincode = item.pincode
                },
                dataParams: {
                  aggregate: true
                },
              }
            },
          },
        ]
      },
      {
        fieldGroupClassName: "row padding-custom",
        fieldGroup: [
          {
            className: "col-12",
            type: "button",
            templateOptions: {
              type: "submit",
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.coApplicantName === undefined || this.model?.coApplicantRelation === undefined || this.model?.coApplicantPhoneNumber === undefined || this.model?.coApplicantOccupation === undefined || this.model?.coApplicantProfession === undefined || this.model?.coApplicantIncome === undefined || this.model?.coApplicantPincode === undefined) {
                  this.model["error"] = "Hello world"
                }
                else {
                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                    }
                    if (this.loanService.partnerDetails) {
                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company.name;
                    }
                    this.trackEvent("Next Button of Collateral Loan on Loan Widget  Clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if ([undefined, "", " "].includes(this.model?.coApplicantName) || [undefined, "", " "].includes(this.model?.coApplicantRelation) || [undefined, "", " "].includes(this.model?.coApplicantPhoneNumber) || [undefined, "", " "].includes(this.model?.coApplicantOccupation) || [undefined, "", " "].includes(this.model?.coApplicantProfession) || [undefined, "", " "].includes(this.model?.coApplicantIncome) || [undefined, "", " "].includes(this.model?.coApplicantPincode)) {
                  return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                }
                else {
                  return "primary w-100 py-3 fw-bold rounded-custom "
                }
              }
            },
          },
        ]
      }
    ];
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response };
      if (partnerDetails) {
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
      }
      else {
        this.isPartnerLink = false;
      }
    })
  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
      return;
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['personal-details']);
      return;
    }
    else if (this.loanService?.loanDetails) {
      if (this.loanService?.loanDetails?.loanType !== 'Unsecured Loan(without Property)') {
        if (this.isPartnerLink) {
          this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
          return;
        }
        this.route.navigate(['/loan-details']);
        return;
      }
    }

    this.dataPreprocessor();
  }

  dataPreprocessor() {
    this.model = { ...this.loanService.loanDetails };
    if (this.model.coApplicantIncome) {
      this.model.coApplicantIncome = this.prepareViewLoanAmount(this.model.coApplicantIncome)
    }

    if (this.orientation === 'horizontal') {
      this.setLayout();
    }
    else {
      this.setMobileLayout();
    }
  }

  prepareViewLoanAmount(amount: any) {
    return (Number((amount))).toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      currency: 'INR'
    }).replace("$", "").split(".")[0].toString();
  }

  dataProcessor(data: any) {
    delete data?.typeOfCollateral;
    delete data?.valueOfCollateral;
    if (data?.error) {
      delete data?.error;
      this.model.error = undefined;
    }
    if (data?.coApplicantPan) {
      data.coApplicantPan = data?.coApplicantPan.toUpperCase();
    }
    if (data?.coApplicantIncome) {
      data.coApplicantIncome = Number(data?.coApplicantIncome?.replaceAll(",", ""));
    }
    if (!data?.studentId) {
      data["studentId"] = this.loanService?.studentDetails?.id;
    }
    data = this.removeEmpty(data);
    return data;
  }

  removeEmpty(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      else if (typeof obj[propName] == 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj
  }

  onSubmit(event: any) {
    if (!event?.error) {
      this.loanService.updateLoanLeadToApplied();
      this.loanService.saveLoanApplication(this.model).then(() => {
        if (this.isPartnerLink) {
          this.route.navigate(['result/' + this.loanService?.partnerDetails?.uid]);
          return;
        }
        this.route.navigate(['result'])
      })

      gtag('event', 'non_collateral_details_submit', {
        'event_category': 'button',
        'event_label': 'Non collateral details submit button',
        'value': "Non collateral details information"  
      });
  
      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.model?.mobile
      })
  

    }
  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['./loan-details'])
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  checkPanNumber(pan) {
    let params = {
      where: {
        pan: pan?.toUpperCase(),
      }
    }
    return this.apiHelper.getData("users/check-existing-pan-loan", params).then((res: any[]) => {
      return res?.length;
    })
  }

  checkMobileAvailable(mobileNo) {
    if (this.loanService?.studentDetails?.mobile === mobileNo) {
      return true
    }
    else {
      return false
    }
  }

  emitStep(ev: any) {
    if (this.isPartnerLink) {
      this.route.navigate(["loan-details/" + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(["loan-details"]);
    let newModel = { ...this.model };
    this.model = undefined;
    this.model = newModel;

  }
}
